export default __webpack_public_path__ + "static/818-1713ab4d8bca305ece106a5c1c67bfd2.gif";